// extracted by css-extract-rspack-plugin
export default {"kibScope":"kibScope-KXzMSJ","orderHeader":"orderHeader-dBnOux","orderNumber":"orderNumber-xoJB1o","statusLabel":"statusLabel-Xj_hex","orderDetailsFrame":"orderDetailsFrame-gi_ZPB"};